import React from "react";
import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";

import { errors } from "../../helper/Error";

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    content: {
      textAlign: "center",
    },
    text: {
      marginTop: theme.spacing(4),
      fontSize: 20,
      whiteSpace: "pre-line", // \nで改行用
    },
    errorCode: {
      marginTop: theme.spacing(3),
      marginBottom: 0,
      fontSize: 18,
      whiteSpace: "pre-line", // \nで改行用
    },
    closeButton: {
      fontSize: 18,
    },
  })
);

const ErrorDialog = React.memo((props) => {
  const { open, onClose, error = errors.APP_OTHER_ERROR } = props;
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent className={classes.content}>
        <DialogContentText className={classes.text}>
          {error.text}
        </DialogContentText>

        <DialogContentText className={classes.errorCode}>
          {`エラーコード：${error.code}`}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          color="primary"
          className={classes.closeButton}
        >
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default ErrorDialog;
